import {ExtendBorrowCheckContainer} from "../../../containers/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowCheckContainer"
export function ExtendBorrowCheckPage () {
    return(
        <ExtendBorrowCheckContainer/>
    )
}